import { FullBetSlipState } from '../types';

import bigStakes, { BigStakesActions } from './bigStakes';
import conflict, { ConflictActions } from './conflict';
import entries, { EntriesActions } from './entries';
import oneClickBet, { OneClickBetActions } from './oneClickBet';
import preferences, { PreferencesActions } from './preferences';
import stakeTypes, { StakeTypesActions } from './stakeTypes';
import submission, { SubmissionActions } from './submission';
import waitingInQueue, { WaitingInQueueActions } from './waitingInQueue';

// ---

type BetSlipActions =
  | PreferencesActions
  | OneClickBetActions
  | EntriesActions
  | StakeTypesActions
  | SubmissionActions
  | ConflictActions
  | WaitingInQueueActions;

const reducers = (state: FullBetSlipState, action: BetSlipActions) => ({
  preferences: preferences(state?.preferences, action as PreferencesActions),
  oneClickBet: oneClickBet(state?.oneClickBet, action as OneClickBetActions),
  entries: entries(state?.entries, action as EntriesActions, state),
  stakeTypes: stakeTypes(state?.stakeTypes, action as StakeTypesActions, state),
  submission: submission(state?.submission, action as SubmissionActions),
  conflict: conflict(state?.conflict, action as ConflictActions),
  bigStakes: bigStakes(state?.bigStakes, action as BigStakesActions),
  waitingInQueue: waitingInQueue(state?.waitingInQueue, action as WaitingInQueueActions),
});

export default reducers;
